import { BaseNotification } from './base-notification.model';

export interface BaseNotificationsState {
    itemList: BaseNotification[];
    loaded: boolean;
}

export const baseInitialState: BaseNotificationsState = {
    itemList: [],
    loaded: false,
};

